<template>
    <div class="model" style="height: auto;">
        <router-link to="user/channel">
            <div class="model_header">
                <div class="flex" style="height: 100%">
                    <div class="flex flex1">
                        <svg class="icon icon-reset" aria-hidden="true" slot="icon">
                            <use xlink:href="#icon-channel"></use>
                        </svg>
                        <span class="model_title">{{ menuTypes.chanel }}</span>
                    </div>
                    <div>
                            <div>
                            <svg class="icon arrow" aria-hidden="true" slot="icon">
                                    <use xlink:href="#icon-more"></use>
                                </svg>
                            </div>
                    </div>
                </div>
            </div>
        </router-link>
        <div class="flex model_body flex">
            <div class="data-table flex1 background" id="channel"></div>
        </div>
    </div>
</template>

<script>
import 'echarts/lib/chart/pie';
import { echartsConfig } from '../../utils/utils';
 
export default {
  name: 'Channel',
  props: ['menuTypes', 'property', 'channel', 'initChannel'],
  watch: {
      initChannel: function(val) {
          if (val) this.init()
      }
  },
  mounted() {
      const self = this;
      setTimeout(() => {
          this.init();
      }, 1000);
    // this.init();
  },
  methods: {
      init: function() {
        const container = document.getElementById('channel')
        let myEcharts = this.$echarts.init(container)
        const total = this.channel.value.reduce((s, t) => s + t, 0);
        let option = {
            width: '85%',
            tooltip : {
                show: true,
                trigger: 'item',
                formatter: "{b}<br/>{c} ({d}%)"
            },
            grid: {
                x: 30,
                y: 30,
            },
            series: [{
              type: 'pie',
               labelLine : {
                    normal : {
                    length : 8,
                    length2 : 10
                    }
                },
              data: this.channel.value.map((s, index) => ({ value: s, name: this.channel.axis[index] }))
                .filter((s, index) => index < echartsConfig.minNumber)
                .filter((s, index) => s.value / total > echartsConfig.minPercent)
                .sort(function (a, b) { return a.value - b.value; }),
//            itemStyle: {
//                  normal: {
//                      color: function(params) { 
//                          var colorList = ['#334B5C', '#D53A35', '#7FAE90', '#9FDABF']; 
//                          return colorList[(params.dataIndex + 1) % 4] 
//                      }
//                  },
//              },
            }],
        }
        myEcharts.setOption(option)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.model_header {
    line-height: unset;
    padding: 0 .1rem;
}

.flex {
    align-items: center;
}

.icon-reset {
    margin: 0;
    width: 1em;
    height: 1em;
    font-size: .24rem;
}
.arrow {
    color: #757575;
}
</style>
<style scoped>
.channel {
    position: absolute;
    right: .2rem;
    margin-top: 1.55rem;
}
.number {
    position: absolute;
}
.data-table{
    height: 2.23rem;
    width: 3.20rem;
}
.background {
    background: url('../../../static/img/empty.png') no-repeat center 30% !important;
    background-repeat: no-repeat;
    background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/userElement/Channel.vue